import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import enLocales from './en/translate.json';
import jaLocales from './ja/translate.json';

// ----------------------------------------------------------------------

let lng = 'ja';

if (typeof localStorage !== 'undefined') {
  lng = localStorage.getItem('i18nextLng') || 'ja';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      ja: { translations: jaLocales },
    },
    lng,
    fallbackLng: 'ja',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
